import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';

const messageTypes: {type: string; iconClass: string; containerClass: string; ariaLabel: string}[] = [
  {
    type: 'info',
    iconClass: 'ds-icon--info',
    containerClass: 'ds-message--info',
    ariaLabel: 'info message',
  },
  {
    type: 'success',
    iconClass: 'ds-icon--checked-circle',
    containerClass: 'ds-message--success',
    ariaLabel: 'success message',
  },
  {
    type: 'warning',
    iconClass: 'ds-icon--exclamation-circle',
    containerClass: 'ds-message--warning',
    ariaLabel: 'warning message',
  },
  {
    type: 'error',
    iconClass: 'ds-icon--close-outline',
    containerClass: 'ds-message--error',
    ariaLabel: 'error message',
  }
];

@Component({
  selector: 'ds-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
})
export class MessageComponent implements OnInit {

  private _messages: string[];
  @Input() set messages(messages: string[]) {
    this._messages = messages;
    this.setIsMultiLine();
  }
  get messages() {
    return this._messages;
  }
  @Input() message: string;
  @Input() type: string = messageTypes[0].type;
  @Input() closable = false;
  @Input() highlighted = false;
  @Input() showIcon: boolean = true;
  @Output() canBeClosed = new EventEmitter();
  @ViewChild('closeBtn') closeBtnElement: ElementRef;

  messageIconClass = messageTypes[0].iconClass;
  messageContainerClass = messageTypes[0].containerClass;
  messageContainerAriaLabel = messageTypes[0].ariaLabel;
  isMultiLine = false;
  close = false;

  ngOnInit(): void {
    this.cleanupStringInputs();
    this.assignTypeClasses();
    this.setIsMultiLine();
  }

  cleanupStringInputs(): void {
    this.type = this.type.toLowerCase().trim();
    if (this.message) {
      this.message = this.message.trim();
    }
    if (this.messages) {
      this.messages = this.messages.map((m) => m.trim());
    }
  }

  assignTypeClasses(): void {
    messageTypes.forEach((mType) => {
      if (mType.type === this.type) {
        this.messageIconClass = mType.iconClass;
        this.messageContainerClass = mType.containerClass;
        this.messageContainerAriaLabel = mType.ariaLabel;
      }
    });
  }

  setIsMultiLine(): void {
    if (this.messages && this.messages.length) {
      this.isMultiLine = true;
    }
  }

  closeMessage(): void {
    this.close = true;
    this.canBeClosed.emit();
  }

  public focusCloseButton(): void {
    setTimeout(() => {
      if (this.closable && !this.close && this.closeBtnElement) {
        this.closeBtnElement.nativeElement.focus();
      }
    });
  }
}


